export const NAME_INPUT_VIEW = 'NAME_INPUT_VIEW';
export const NAME_INPUT = 'NAME_INPUT';
export const NAME_COMPLETE_BUTTON = 'NAME_COMPLETE_BUTTON';
